import { observable, decorate, action } from "mobx";
import { PricingState, waiting, loading, ready, PricingPayload } from "./Types";

export type QuotationParams = {
  [key: string]: string | number | boolean;
};

class PricingStore {
  pricingState: PricingState;
  quotationParams: QuotationParams;

  constructor() {
    this.pricingState = waiting();
    this.quotationParams = {};
  }

  loading = () => {
    this.pricingState = loading();
  };

  ready = (pricing: PricingPayload) => {
    this.pricingState = ready(pricing);
  };

  setQuotationParams = (quotationParams: QuotationParams) => {
    this.quotationParams = quotationParams;
  };
}

decorate(PricingStore, {
  pricingState: observable,
  quotationParams: observable,
  loading: action,
  ready: action,
  setQuotationParams: action,
});

export default PricingStore;
